import { NavLink, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  CalendarDays,
  Receipt,
  Tags,
  BarChart3,
  Shield,
  Landmark,
  Scale,
  Grid3X3,
} from 'lucide-react';
import { useAuthStore } from '@/shared/stores/authStore';
import { cn } from '@/shared/lib/utils';

const navigation = [
  { name: 'Periodos', path: '/periodos', icon: CalendarDays },
  { name: 'P&L', path: '/', icon: LayoutDashboard, requireViewFinancials: true },
  { name: 'Centros', path: '/centros-costo', icon: Landmark },
  { name: 'Clasif.', path: '/gasto-clasificado', icon: Grid3X3 },
  { name: 'Balance', path: '/balance-general', icon: Scale, requireViewFinancials: true },
  { name: 'Deducciones', path: '/deducciones', icon: Receipt, requireManage: true },
  { name: 'Clasificaciones', path: '/clasificaciones', icon: Tags, requireManage: true },
  { name: 'Análisis', path: '/analisis', icon: BarChart3, requireViewFinancials: true },
  { name: 'Auditoría', path: '/auditoria', icon: Shield, requireManage: true },
];

export function BottomNav() {
  const canManage = useAuthStore(state => state.canManage)();
  const canViewFinancials = useAuthStore(state => state.canViewFinancials)();
  const location = useLocation();

  const visibleNav = navigation.filter(
    item =>
      (!item.requireManage || canManage) &&
      (!item.requireViewFinancials || canViewFinancials)
  );

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 safe-bottom safe-x lg:hidden">
      <div className="mx-3 mb-3 rounded-2xl border border-border bg-surface/95 px-2 py-2 shadow-elevated backdrop-blur-xl">
        <div className="flex items-center justify-around">
          {visibleNav.map(item => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;

            return (
              <NavLink
                key={item.path}
                to={item.path}
                className={cn(
                  'relative flex flex-col items-center gap-1 rounded-xl px-2 py-1.5 transition-all duration-200 min-w-[3rem]',
                  isActive
                    ? 'text-primary'
                    : 'text-text-muted hover:text-text-secondary'
                )}
              >
                <span
                  className={cn(
                    'flex h-9 w-9 items-center justify-center rounded-xl transition-all duration-200',
                    isActive
                      ? 'bg-primary-muted text-primary shadow-sm'
                      : 'bg-transparent'
                  )}
                >
                  <Icon className={cn('h-5 w-5', isActive && 'stroke-[2.5px]')} />
                </span>
                <span className={cn('text-[10px] font-semibold', isActive && 'text-text-primary')}>
                  {item.name}
                </span>
                {isActive && (
                  <span className="absolute -bottom-0.5 h-1 w-1 rounded-full bg-primary" />
                )}
              </NavLink>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
